// extracted by mini-css-extract-plugin
module.exports = {"box":"Upster_box__2un9c","wrapper":"Upster_wrapper__24O6o","contact":"Upster_contact__3Se1X","name":"Upster_name__3BH-t"};